import { DataField } from "@iventis/domain-model/model/dataField";
import { DataFieldListItem } from "@iventis/domain-model/model/dataFieldListItem";
import { DataFieldType } from "@iventis/domain-model/model/dataFieldType";
import { DataFieldValue } from "@iventis/domain-model/model/dataFieldValue";
import { EventBlock } from "@iventis/domain-model/model/eventBlock";
import { EventBlockSystemDataFieldType } from "@iventis/domain-model/model/eventBlockSystemDataFieldType";
import { EventBlockTypeDataFields } from "@iventis/domain-model/model/eventBlockTypeDataFields";
import { VenueLocation } from "@iventis/domain-model/model/venueLocation";
import { Content } from "@iventis/translations/content/typed-content";
import { translate } from "@iventis/translations/translation";

export const isSystemDataField = (dataFieldId: string, eventBlockTypeDataFields: EventBlockTypeDataFields[]) => {
    const dataField = eventBlockTypeDataFields?.find((eventBlockTypeDataField) => eventBlockTypeDataField.dataFieldId === dataFieldId);
    // If the datafield can not be found in the event block datafield types
    if (dataField == null) {
        return false;
    }
    // If the system datafield property is not null return true
    return dataField.systemDataFieldType !== null;
};

export const getSystemDataFieldFromEventBlock = (systemDataFieldType: EventBlockSystemDataFieldType, eventBlock: EventBlock) => {
    const systemDataField = eventBlock.type.dataFields.find((dataField) => dataField.systemDataFieldType === systemDataFieldType);
    return eventBlock.dataFieldValues.find((dataFieldValue) => dataFieldValue.dataField.id === systemDataField?.dataFieldId);
};

export const getDataFieldDisplayableValue = (dataFieldValue: DataFieldValue) => {
    let value: string | number;

    if (dataFieldValue == null) {
        throw new Error("Datafield value is undefined");
    }

    switch (dataFieldValue?.dataField?.type) {
        case DataFieldType.Number:
            value = dataFieldValue.value as number;
            break;
        case DataFieldType.List:
            value = (dataFieldValue.value?.name as string) || "";
            break;
        case DataFieldType.Text:
            value = dataFieldValue.value as string;
            break;
        case DataFieldType.Tickbox:
            value = dataFieldValue.value ? translate(Content.common.yes) : translate(Content.common.no);
            break;
        default:
            throw new Error("Data field type invalid");
    }

    if (typeof value !== "number" && typeof value !== "string") {
        throw new Error("Datafield value is not type of string or number");
    }
    return value;
};

export const dataFieldExists = (item: EventBlock | VenueLocation, dataFieldName: string) => {
    const { dataFieldValues } = item;
    return dataFieldValues.some((dataFieldValue) => dataFieldValue.dataField.name === dataFieldName);
};

export const getDataFieldListItemDisplayTextWithCode = (dataFieldListItem: DataFieldListItem, dataField: DataField) => {
    const displayText = dataFieldListItem.name;
    const code = dataFieldListItem.metaData?.[dataField.customerIdentifierName];
    return code ? `${displayText} (${code})` : displayText;
};
